import type { Task } from '@core/fhir-r4/fhir';
import type { PreTriageGateway, PreTriageGatewayResult } from '@core/ports/PreTriageGateway';

export class ApplyPreTriageTaskUseCase {
  public constructor(private readonly preTriageGateway: PreTriageGateway) {}

  public execute(taskPayload: Task): Promise<PreTriageGatewayResult> {
    return this.preTriageGateway.applyTask(taskPayload);
  }
}